/**
 * TAMIX SAAS PLATFORM - Main App Component
 * ========================================
 * Generated: 2025-09-22 - Session 6 Sprint 0
 * Routing, Authentication Context, Layout
 */

import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

// Components
import Layout from '@/components/layout/Layout'
import LoginForm from '@/components/auth/LoginForm'
import TenantList from '@/components/tenants/TenantList'
import Dashboard from '@/components/dashboard/Dashboard'

// Pages
import NotFound from '@/pages/NotFound'

const App: React.FC = () => {
  const { isAuthenticated, user } = useAuthStore()

  return (
    <div className="app">
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginForm />
          } 
        />
        
        {/* Protected Routes */}
        <Route 
          path="/" 
          element={
            isAuthenticated ? <Layout /> : <Navigate to="/login" replace />
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          
          {/* Admin Routes - Only for platform administrators */}
          {user?.role === 'platform_admin' && (
            <Route path="tenants" element={<TenantList />} />
          )}
        </Route>

        {/* Catch all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  )
}

export default App